document.addEventListener("DOMContentLoaded", (event) => {
  // Only initialize Swiper for carousel layout
  const carouselElements = document.querySelectorAll('.latest_news_v2__list--carousel');

  carouselElements.forEach((element) => {
    const swiper = new Swiper(element, {
      loop: true,
      loopPreventsSliding: true,
      autoplay: {
          delay: 7500,
          disableOnInteraction: false,
      },
      slidesPerView: 1.15,
      spaceBetween: 26,
      breakpoints: {
        564: {
          slidesPerView: 1.5,
          spaceBetween: 22,
        },
        748: {
          slidesPerView: 2,
          spaceBetween: 22,
        },
        991: {
          slidesPerView: 2.5,
          spaceBetween: 22,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 22,
        }
      }
    });
  });
});
  
